import { Response } from '..'

// POST /api/autotask/contract-service-adjustments
export async function createContractServiceAdjustment(data, requestOptions = {}) {
	return Response.request('/api/autotask/contract-service-adjustments', data, requestOptions)
}
